var map = {
	"./bunte-osteraktion/image1.webp": 6399,
	"./bunte-osteraktion/image2.webp": 3054,
	"./bunte-osteraktion/image3.webp": 2777,
	"./erstklässler-2025/image1.webp": 4437,
	"./erstklässler-2025/image2.webp": 5656,
	"./erstklässler-2025/image3.webp": 1915,
	"./erstklässler-2025/image4.webp": 7798,
	"./erstklässler-2025/image5.webp": 8993,
	"./f1d90f_8bbbb3749407488d92559e7c57c74b51~mv2.jpeg": 8260,
	"./frankfurt-tafel-kreativ/image1.jpeg": 6467,
	"./frankfurt-tafel-kreativ/image2.jpeg": 3846,
	"./frankfurt-tafel-kreativ/image3.jpeg": 7069,
	"./frankfurt-tafel-kreativ/image4.jpeg": 6920,
	"./frankfurt-tafel-kreativ/image5.jpeg": 7983,
	"./frühlingsfest/image01.webp": 8208,
	"./frühlingsfest/image10.webp": 9294,
	"./frühlingsfest/image11.webp": 9017,
	"./frühlingsfest/image12.webp": 8300,
	"./frühlingsfest/image13.webp": 1743,
	"./frühlingsfest/image14.webp": 2962,
	"./frühlingsfest/image15.webp": 9373,
	"./frühlingsfest/image16.webp": 1472,
	"./frühlingsfest/image17.webp": 3683,
	"./frühlingsfest/image18.webp": 5926,
	"./frühlingsfest/image19.webp": 657,
	"./frühlingsfest/image2.webp": 5027,
	"./frühlingsfest/image20.webp": 7973,
	"./frühlingsfest/image21.webp": 3946,
	"./frühlingsfest/image22.webp": 8043,
	"./frühlingsfest/image23.webp": 2696,
	"./frühlingsfest/image24.webp": 5873,
	"./frühlingsfest/image25.webp": 6998,
	"./frühlingsfest/image26.webp": 2471,
	"./frühlingsfest/image27.webp": 7764,
	"./frühlingsfest/image28.webp": 2237,
	"./frühlingsfest/image29.webp": 2322,
	"./frühlingsfest/image30.webp": 9816,
	"./frühlingsfest/image31.webp": 7195,
	"./frühlingsfest/image4.webp": 6937,
	"./frühlingsfest/image5.webp": 7838,
	"./frühlingsfest/image6.webp": 7135,
	"./frühlingsfest/image7.webp": 9916,
	"./frühlingsfest/image8.webp": 4181,
	"./frühlingsfest/image9.webp": 6330,
	"./herbst-und-kulturfest/image1.webp": 6501,
	"./herbst-und-kulturfest/image2.webp": 6744,
	"./herbst-und-kulturfest/image3.webp": 4123,
	"./herbst-und-kulturfest/image4.webp": 6982,
	"./herbst-und-kulturfest/image5.webp": 8657,
	"./herbst-und-kulturfest/image6.webp": 1172,
	"./herbst-und-kulturfest/image7.webp": 3767,
	"./herbst-und-kulturfest/image8.webp": 1970,
	"./img1.JPG": 5455,
	"./img2.JPG": 704,
	"./img3.jpg": 78,
	"./img4.jpg": 7141,
	"./kindertag/image1.jpeg": 7711,
	"./kindertag/image2.jpeg": 9282,
	"./kindertag/image3.jpeg": 3561,
	"./kindertag/image4.jpeg": 8684,
	"./kindertag/image5.jpeg": 9011,
	"./kreative-leinwände/image1.jpeg": 9484,
	"./kreative-leinwände/image2.jpeg": 2381,
	"./kreative-leinwände/image3.jpeg": 7414,
	"./kreative-leinwände/image4.jpeg": 4335,
	"./kreative-leinwände/image5.jpeg": 3816,
	"./kreative-leinwände/image6.jpeg": 9257,
	"./kreative-leinwände/image7.jpeg": 7042,
	"./muttertag/image1.webp": 2766,
	"./muttertag/image2.webp": 9919,
	"./tag-der-offenen-tur-15-11-2025/image1.webp": 273,
	"./tag-der-offenen-tur-15-11-2025/image10.webp": 6383,
	"./tag-der-offenen-tur-15-11-2025/image11.webp": 1500,
	"./tag-der-offenen-tur-15-11-2025/image12.webp": 5769,
	"./tag-der-offenen-tur-15-11-2025/image13.webp": 9742,
	"./tag-der-offenen-tur-15-11-2025/image14.webp": 1379,
	"./tag-der-offenen-tur-15-11-2025/image15.webp": 5616,
	"./tag-der-offenen-tur-15-11-2025/image17.webp": 3730,
	"./tag-der-offenen-tur-15-11-2025/image18.webp": 7527,
	"./tag-der-offenen-tur-15-11-2025/image19.webp": 6516,
	"./tag-der-offenen-tur-15-11-2025/image2.webp": 2932,
	"./tag-der-offenen-tur-15-11-2025/image20.webp": 9972,
	"./tag-der-offenen-tur-15-11-2025/image22.webp": 9206,
	"./tag-der-offenen-tur-15-11-2025/image23.webp": 8081,
	"./tag-der-offenen-tur-15-11-2025/image24.webp": 1256,
	"./tag-der-offenen-tur-15-11-2025/image26.webp": 6154,
	"./tag-der-offenen-tur-15-11-2025/image27.webp": 181,
	"./tag-der-offenen-tur-15-11-2025/image28.webp": 8252,
	"./tag-der-offenen-tur-15-11-2025/image29.webp": 9839,
	"./tag-der-offenen-tur-15-11-2025/image3.webp": 4791,
	"./tag-der-offenen-tur-15-11-2025/image30.webp": 9265,
	"./tag-der-offenen-tur-15-11-2025/image31.webp": 9510,
	"./tag-der-offenen-tur-15-11-2025/image32.webp": 8199,
	"./tag-der-offenen-tur-15-11-2025/image33.webp": 4020,
	"./tag-der-offenen-tur-15-11-2025/image34.webp": 101,
	"./tag-der-offenen-tur-15-11-2025/image36.webp": 8635,
	"./tag-der-offenen-tur-15-11-2025/image37.webp": 696,
	"./tag-der-offenen-tur-15-11-2025/image39.webp": 9406,
	"./tag-der-offenen-tur-15-11-2025/image4.webp": 8026,
	"./tag-der-offenen-tur-15-11-2025/image41.webp": 2049,
	"./tag-der-offenen-tur-15-11-2025/image42.webp": 4564,
	"./tag-der-offenen-tur-15-11-2025/image45.webp": 6245,
	"./tag-der-offenen-tur-15-11-2025/image46.webp": 136,
	"./tag-der-offenen-tur-15-11-2025/image5.webp": 9125,
	"./tag-der-offenen-tur-15-11-2025/image51.webp": 9368,
	"./tag-der-offenen-tur-15-11-2025/image52.webp": 8293,
	"./tag-der-offenen-tur-15-11-2025/image6.webp": 4728,
	"./tag-der-offenen-tur-15-11-2025/image7.webp": 7547,
	"./tag-der-offenen-tur-15-11-2025/image8.webp": 2558,
	"./tag-der-offenen-tur-15-11-2025/image9.webp": 2281,
	"./tag-der-offenen-tur-21-02-2026/image0.webp": 6796,
	"./tag-der-offenen-tur-21-02-2026/image1.webp": 1087,
	"./tag-der-offenen-tur-21-02-2026/image11.webp": 8990,
	"./tag-der-offenen-tur-21-02-2026/image13.webp": 348,
	"./tag-der-offenen-tur-21-02-2026/image15.webp": 7154,
	"./tag-der-offenen-tur-21-02-2026/image18.webp": 8849,
	"./tag-der-offenen-tur-21-02-2026/image19.webp": 9094,
	"./tag-der-offenen-tur-21-02-2026/image2.webp": 9150,
	"./tag-der-offenen-tur-21-02-2026/image20.webp": 4066,
	"./tag-der-offenen-tur-21-02-2026/image24.webp": 398,
	"./tag-der-offenen-tur-21-02-2026/image26.webp": 5756,
	"./tag-der-offenen-tur-21-02-2026/image27.webp": 2847,
	"./tag-der-offenen-tur-21-02-2026/image28.webp": 5866,
	"./tag-der-offenen-tur-21-02-2026/image29.webp": 6965,
	"./tag-der-offenen-tur-21-02-2026/image3.webp": 3657,
	"./tag-der-offenen-tur-21-02-2026/image30.webp": 1319,
	"./tag-der-offenen-tur-21-02-2026/image31.webp": 7620,
	"./tag-der-offenen-tur-21-02-2026/image34.webp": 1179,
	"./tag-der-offenen-tur-21-02-2026/image36.webp": 3701,
	"./tag-der-offenen-tur-21-02-2026/image37.webp": 1834,
	"./tag-der-offenen-tur-21-02-2026/image40.webp": 5576,
	"./tag-der-offenen-tur-21-02-2026/image41.webp": 3947,
	"./tag-der-offenen-tur-21-02-2026/image44.webp": 1764,
	"./tag-der-offenen-tur-21-02-2026/image45.webp": 2775,
	"./tag-der-offenen-tur-21-02-2026/image47.webp": 8481,
	"./tag-der-offenen-tur-21-02-2026/image48.webp": 4512,
	"./tag-der-offenen-tur-21-02-2026/image5.webp": 5507,
	"./tag-der-offenen-tur-21-02-2026/image53.webp": 2488,
	"./tag-der-offenen-tur-21-02-2026/image54.webp": 4113,
	"./tag-der-offenen-tur-21-02-2026/image59.webp": 8738,
	"./tag-der-offenen-tur-21-02-2026/image6.webp": 5186,
	"./tag-der-offenen-tur-21-02-2026/image60.webp": 8910,
	"./tag-der-offenen-tur-21-02-2026/image61.webp": 3417,
	"./tag-der-offenen-tur-21-02-2026/image65.webp": 9885,
	"./tag-der-offenen-tur-21-02-2026/image66.webp": 5216,
	"./tag-der-offenen-tur-21-02-2026/image67.webp": 5267,
	"./tag-der-offenen-tur-21-02-2026/image68.webp": 9958,
	"./tag-der-offenen-tur-21-02-2026/image7.webp": 125,
	"./tag-der-offenen-tur-21-02-2026/image71.webp": 3488,
	"./tag-der-offenen-tur-21-02-2026/image8.webp": 8036,
	"./tag-der-offenen-tur-21-02-2026/image9.webp": 631,
	"./welttag-des-buches/image1.webp": 3613,
	"./welttag-des-buches/image12.webp": 9325,
	"./welttag-des-buches/image15.webp": 5996,
	"./welttag-des-buches/image18.webp": 6539,
	"./welttag-des-buches/image19.webp": 2808,
	"./welttag-des-buches/image20.webp": 4360,
	"./welttag-des-buches/image21.webp": 4267,
	"./welttag-des-buches/image22.webp": 1274,
	"./welttag-des-buches/image23.webp": 6789,
	"./welttag-des-buches/image3.webp": 7923,
	"./welttag-des-buches/image5.webp": 3257,
	"./welttag-des-buches/image6.webp": 2540,
	"./welttag-des-buches/image7.webp": 5983,
	"./welttag-des-buches/image8.webp": 9002,
	"./welttag-des-buches/image9.webp": 2482,
	"./winterfest/image1.webp": 7974,
	"./winterfest/image10.webp": 4170,
	"./winterfest/image11.webp": 8437,
	"./winterfest/image12.webp": 8680,
	"./winterfest/image13.webp": 6059,
	"./winterfest/image14.webp": 8918,
	"./winterfest/image15.webp": 4241,
	"./winterfest/image16.webp": 3108,
	"./winterfest/image17.webp": 5703,
	"./winterfest/image2.webp": 2231,
	"./winterfest/image3.webp": 8532,
	"./winterfest/image4.webp": 4613,
	"./winterfest/image5.webp": 2746,
	"./winterfest/image6.webp": 2091,
	"./winterfest/image8.webp": 1705,
	"./winterfest/image9.webp": 3918
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8076;